export default {
  about: {
    hero: {
      eyebrow: 'About us',
      title: 'Personal. Professional. Precise.',
      lead: '{{name}} stands for individually planned video surveillance and personal support from a single source.',
    },
    story: {
      quote: '“Instead of selling ready-made packages, every property is considered according to its actual needs – from the desired image areas to the mounting points and recording and app setup.”',
      p1: '{{name}} is led by {{owner}} – your personal contact from the first consultation to ongoing support. He has been working in security technology for over 20 years and has completed hundreds of projects for private and commercial customers in that time.',
      p2: 'The long-standing experience covers planning and installation of camera systems in family homes, apartment buildings, retail stores, offices, practices, hospitality businesses, warehouses, workshops and production areas. Every project is considered individually – because no property is like another.',
      p3: 'Depending on the project requirements, {{name}} uses proven systems from Hikvision and Safire, among others. Solutions from other well-known manufacturers can also be individually planned and procured.',
      p4: '{{name}} sees itself not as a mere seller, but as a long-term partner. After installation, personal contact remains – for questions, maintenance, extensions or simply to make sure everything works.',
    },
    owner: {
      subtitle: 'Security technology from Hainburg',
      photoPlaceholder: 'Owner photo coming soon',
      role: 'Owner & contact person',
    },
    milestonesTitle: 'Experience that makes itself felt',
    milestones: {
      '0': { year: 'Over 20 years', desc: 'Experience in planning and installing camera systems for private and commercial customers in the Rhine-Main region.' },
      '1': { year: 'Hundreds of completed projects', desc: 'From family homes to retail spaces to large commercial systems – every project individually planned.' },
      '2': { year: 'Manufacturer-independent', desc: 'We choose the right technology for your requirements, depending on the project from various well-known manufacturers.' },
    },
    valuesTitle: 'What makes {{name}} special',
    values: {
      '0': { title: 'Individual planning', desc: 'No ready-made packages. Every property is considered according to its actual needs.' },
      '1': { title: 'Professional implementation', desc: 'Clean installation, correct alignment and professional cabling.' },
      '2': { title: 'Digital connection', desc: 'Smartphone app, remote access and notifications – set up and explained.' },
      '3': { title: 'Personal support', desc: 'One contact person. Trusted. Reliable. Even after installation.' },
    },
    cta: {
      title: 'Get to know us',
      lead: 'A non-binding initial conversation quickly shows whether we fit together. We look forward to getting to know your project.',
      primary: 'Arrange an appointment',
      secondary: 'Frequently asked questions',
    },
  },
};